import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import integrationsEsCL from './locales/es-CL.json';
import integrationsEnUS from './locales/en-US.json';
import integrationsPtBR from './locales/pt-BR.json';

export const integrationsI18n = buildScopedI18n({
  esCL: integrationsEsCL,
  enUS: integrationsEnUS,
  ptBR: integrationsPtBR,
});
